import React, { useContext, useEffect, useState } from "react";
//import AdSense from "react-adsense";
//import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import HeroBanner from "../../components/HeroBanner";
import CommunityTopSection from "../../components/CommunityTopSection";
import PopularListsSection from "../../components/PopularListsSection";
//import Styles from "../../helpers/Styles";

import {
  GetCategoryByName,
  GetListByIdUser,
  GetRandomUserList,
  GetRanksByCategory,
  RapperRanks,
} from "../../api-requests/Get";

import { UserContext } from "../../context/UserContext";
import PageLoading from "../../components/PageLoading";

const Home = () => {
  //const { t } = useTranslation();
  const { user } = useContext(UserContext);

  const [topRanks, setRanks] = useState<any>(null);
  const [, setRandomUserList] = useState<any>(null);
  const [, setGoatList] = useState<any>({});
  const [category_id, setCategory_id] = useState<any>(null);

  const asyncGetRanks = async () => {
    try {
      await RapperRanks();
    } catch (err) {
      console.log("testSecureResult", err);
    }

    const cat = await GetCategoryByName("Rappers");
    let catId;

    if (cat.success) {
      setCategory_id(cat.category);
      catId = cat.category;
    }

    if (user.isloggedin) {
      const myList = await GetListByIdUser(user.id, catId);

      if (myList[0] !== undefined) {
        setGoatList(myList[0].data);
      }
    }
    const rank = await GetRanksByCategory(catId);
    setRanks(rank);
    const usersList = await GetRandomUserList();
    setRandomUserList(usersList);
  };

  useEffect(() => {
    asyncGetRanks();
  }, [user]);

  if (!category_id) {
    return <PageLoading />;
  }

  return (
    <div>
      <Header />
      <HeroBanner />
      <div className="separator-fade" />
      <CommunityTopSection topRanks={topRanks} categoryId={category_id} />
      <div className="separator-fade" />
      {/*  <div className="flex justify-center">
        <div className={Styles.page_container}>
          <div className="flex justify-center my-4">
            <AdSense.Google
              client="ca-pub-993288253482590"
              slot="5582515344"
              style={{ display: "block" }}
              format="auto"
              responsive="true"
            />
          </div>
        </div>
      </div> */}
      <PopularListsSection />
      <div className="separator-fade" />
      <Footer />
    </div>
  );
};

export default Home;
